// ** Icon Imports
import PropTypes from 'prop-types';
import {Icon} from '@iconify/react';

const IconifyIcon = ({fontSize = '1.5rem', icon, ...rest}) => {
  return <Icon icon={icon} fontSize={fontSize} {...rest} />;
};

IconifyIcon.propTypes = {
  fontSize: PropTypes.string,
  icon: PropTypes.string,
};

export default IconifyIcon;
